module.exports = __webpack_public_path__ + "static/img/sichegongyongbaoxiao.9d2b1752.png";